const TRUNCATION_EPSILON_PX = 0.5;

function toPixels(value: string): number {
    return Number.parseFloat(value) || 0;
}

function getHorizontalChrome(target: HTMLElement): number {
    const style = window.getComputedStyle(target);

    return (
        toPixels(style.paddingLeft) +
        toPixels(style.paddingRight) +
        toPixels(style.borderLeftWidth) +
        toPixels(style.borderRightWidth)
    );
}

export function isTruncated(target: HTMLElement): boolean {
    if (!target.textContent?.trim()) {
        return false;
    }

    const range = document.createRange();
    // jsdom has no Range geometry; there is nothing to measure.
    if (typeof range.getBoundingClientRect !== 'function') {
        return false;
    }
    range.selectNodeContents(target);

    const { width: elementWidth } = target.getBoundingClientRect();
    const availableWidth = elementWidth - getHorizontalChrome(target);
    const { width: contentWidth } = range.getBoundingClientRect();

    return contentWidth - availableWidth > TRUNCATION_EPSILON_PX;
}
